<template>
	<div class="home">
		<Overview
			title="14th International Conference on Brain Energy Metabolism (ICBEM)"
			subtitle="Energy Substrates and Microbiome Govern Brain Bioenergetics and Cognitive Function with Aging"
			dates="October 24-27, 2022"
			location="Santa Fe, New Mexico"
			state="New Mexico"
			country="USA"
		/>
		<v-container>
			<v-row>
				<v-col sm="12" md="9" order-sm="12" order-md="1">
					<div class="home-page-item">
						<h3 class="welcome-title">Welcome to ICBEM</h3>
						<p class="home-page-item-text">
							We invite you to participate in the 14th
							International Conference on Brain Energy Metabolism
							(ICBEM) entitled, "Energy substrates and microbiome
							govern brain bioenergetics and cognitive function
							with aging". The conference will be held at the La
							Fonda on the Plaza Hotel, Santa Fe, New Mexico, USA,
							on
							<span>October 24-27, 2022</span>.
						</p>
						<p class="home-page-item-text">
							This conference brings together a select group of
							leading researchers, clinicians, young scientists,
							and students interested in brain energy metabolism.
							Lectures and discussions will cover latest
							developments in research related to neuronal
							energetics, emerging roles for glycogen in higher
							brain functions, impact of dietary intervention on
							aging, memory, and Alzheimer's disease, roles of the
							microbiome in gut-brain signaling, astrocyte-neuron
							interactions related to cognition and memory, novel
							roles for mitochondria and their metabolites, and
							metabolic neuroimaging in aging and
							neurodegeneration.
						</p>
						<p class="home-page-item-text">
							Traditionally, these meetings provide a forum for
							very lively and informative discussions after the
							talks and during free time and poster sessions.
							Student and fellow participation are strongly
							encouraged, and travel awards for a limited number
							of young scientists will be available.
						</p>
						<p class="home-page-item-text">
							The meeting will be held in Santa Fe, New Mexico,
							USA. The conference is open to all interested
							scientists with registration on a first-come basis
							until reaching a limit of about 100-120 conferees.
							Registration covers most meals and meeting expenses,
							including a farewell dinner. Registration is
							anticipated to open March 1, 2022. Accommodation
							reservations must be booked directly with La Fonda.
						</p>
						<p class="home-page-item-text">
							We anticipate providing about 20 travel stipends,
							depending on available funding, that will be awarded
							to students and postdoctoral fellows on a
							competitive basis. Candidates for travel awards must
							submit their abstracts between February 1 and March
							31, 2022 (See General Info tab for more information)
							and notification of travel awards will be made by
							May 2022.
						</p>
						<p class="home-page-item-text">
							Women, minorities, and persons with disabilities are
							especially encouraged to participate in the Brain
							Energy Metabolism conference. Any participants who
							have special needs are requested to make their
							requirements known to the organizers so that every
							effort can be made to address these needs.
						</p>
						<p class="home-page-item-text">
							Inquiries can be made via the conference email:
							<a
								class="normal-link"
								href="mailto://icbem2020@gmail.com"
								>icbem2020@gmail.com</a
							>. Note that the conference web site link and email
							address retain the original 2020 date because
							previous advertising and conferee notifications used
							this designation and stated that these addresses
							would remain the same.
						</p>
						<p class="home-page-item-text">
							We look forward to meeting you in Santa Fe in
							<span>October 2022</span>.
						</p>
						<div class="home-page-item-footer">
							<p class="bold">Gerald Dienel, Ph.D.</p>
							<p class="bold">In-Young Choi, Ph.D.</p>
							<p>On behalf of the Organizers</p>
						</div>
					</div>
				</v-col>

				<v-col sm="12" md="3" order-sm="1" order-md="12">
					<div class="home-page-sidebar">
						<p><strong>July 31 - Abstract Submission Deadline</strong></p>
						<p><strong>Sept 10 - Bandelier Excursion Registration Deadline</strong></p>
						<p>
							<strong>Sept 26 - LaFonda Hotel Group Rates</strong>
						</p>
						<p>
							<strong class="attention">Sept 29 – Poster submission closed</strong>
						</p>
						<p><strong>Oct. 14 - Conference registration closed</strong></p>
					</div>
				</v-col>
			</v-row>

			<!-- <div class="supporters mh-700">
				<v-layout
					row
					wrap
					align-center
					justify-center
					class="pt-4"
				>
					<v-flex
						xs12
						v-for="logo in majorLogos"
						:key="logo.index"
					>
						<div class="supporter-wrapper">
							<img
								class="supporter-logo"
								v-bind:src="logo.path"
							/>
						</div>
					</v-flex>
				</v-layout>
				<v-layout row wrap class="pb-4">
					<v-flex
						md4
						xs12
						v-for="logo in minorLogos"
						:key="logo.index"
					>
						<div class="supporter-wrapper">
							<img
								class="supporter-logo"
								v-bind:src="logo.path"
							/>
						</div>

					</v-flex>
				</v-layout>
			</div> -->

		</v-container>
	</div>
</template>

<script>
// @ is an alias to /src
import Overview from '@/components/Overview.vue';

export default {
	name: 'home',
	components: {
		Overview
	},
	data: function() {
		return {
			majorLogos: [
				{
					name: 'National Institute on Aging',
					path:
						'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fnih-nia-logo.png?alt=media&token=a9d45851-1226-4897-8137-1369664e7ec0',
					linkUrl: ''
				},
				{
					name: 'International Society for Neurochemistry',
					path:
						'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fisn-logo.png?alt=media&token=b0c5793c-b8af-41e9-8314-eab111dc613b',
					linkUrl: ''
				},
				{
					name:
						'UNM Health Sciences Center for Brain Recovery & Repair',
					path:
						'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2FUNM_logo.png?alt=media&token=e073de33-a633-4075-a7ae-d98a5b71bfb5',
					linkUrl: ''
				}
			],
			minorLogos: [
				{
					name: 'ISBFM',
					path:
						'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2FISCBFM_logo.png?alt=media&token=d6adf82d-c840-4cb8-a499-f0c973b37bb1',
					linkUrl: ''
				},
				{
					name: 'Journal of Neurochemistry',
					path:
						'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2FJNC_logo.png?alt=media&token=7bd89d63-b8c0-417f-8423-291bd4433f62',
					linkUrl: ''
				},
				{
					name: 'Millipore Sigma',
					path:
						'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2FMilliporeSigma_logo.png?alt=media&token=1e08e36e-c859-44da-906d-5173e5d5640a',
					linkUrl: ''
				}
			]
		}
	}
};
</script>
<style scoped>
.supporters {
	padding: 1rem;
	background-color: var(--white-trans);
	margin-bottom: 2rem;
}
.supporter-wrapper {
	padding: 16px;
	text-align: center;
}
.attention {
	font-size: 1.5rem;
	color: var(--white);
}
</style>